import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=54b9df54&scoped=true&"
import script from "./AdminSettings.vue?vue&type=script&lang=js&"
export * from "./AdminSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=54b9df54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b9df54",
  null
  
)

component.options.__file = "www/vues/admin/AdminSettings.vue"
export default component.exports